import React, {useEffect} from "react";
import {useNavigate} from "react-router-dom";
import {useAppDispatch, useAppSelector} from "../../utils/Hooks";
import {LoggedInView} from "../common/LoggedInView";
import Breadcrumbs from "../common/Breadcrumbs";
import ElogInput from "../common/form/ElogInput";
import ElogCheckbox from "../common/form/ElogCheckbox";
import ElogSelect, {Option} from "../common/form/ElogSelect";
import ElogTextarea from "../common/form/ElogTextarea";
import {BreadcrumbLink} from "../../models/BreadcrumbLink";
import {Link} from "react-router-dom";
import {
    createUser, getUsers,
    resetCreateUserStatus,
} from "../../store/reducers/UsersSlice";
import {RequestStatus} from "../../utils/Enums";
import {FormikProvider, useFormik, Form} from "formik";
import {createSMSSender} from "../../store/reducers/SMSSendersSlice";

interface NewUserScreenProps {
}

export interface NewUserFormProps {
    username: string;
    password: string;
    firstname: string;
    lastname: string;
    email?: string;
    quotesEmail?: string;
    signatue?: string;
    logistician: boolean;
    accountant: boolean;
    customs: boolean;
    isChecker: boolean;
    phone: string;
    offline: boolean;
    adminMember: boolean;
    showStatistics: boolean;
    profitGoal: number;
    profitGoalAnnual: number;
    profitGoalCustoms: number;
    profitGoalDirect: number;
}

export const NewUserScreen: React.FC<NewUserScreenProps> = () => {
    const dispatch = useAppDispatch();
    const navigate = useNavigate();

    const usersState = useAppSelector((state) => state.users);
    const requestStatus: RequestStatus = usersState.createUserStatus;

    const breadcrumbLinks: BreadcrumbLink[] = [
        {text: "Kasutajad", url: "/users"},
        {text: "Lisa uus kasutaja", url: "/users/new"},
    ];

    useEffect(() => {
        if (requestStatus === RequestStatus.Success) {
            dispatch(resetCreateUserStatus());
            navigate(breadcrumbLinks[0].url);
        }
    }, [requestStatus]);

    // @ts-ignore
    const formik = useFormik({
        initialValues: {
            username: "",
            password: "",
            firstname: "",
            lastname: "",
            phone: "",
            email: "",
            emailEst: "",
            emailFin: "",
            emailSwe: "",
            quotesEmail: "",
            signatuee: "",
            logistician: false,
            accountant: false,
            isChecker: false,
            customs: false,
            offline: false,
            adminMember: false,
            showStatistics: false,
            profitGoal: 0,
            profitGoalAnnual: 0,
            profitGoalCustoms: 0,
            profitGoalDirect: 0
        },
        onSubmit: (values: any) => {
            dispatch(createUser(values));
        },
        enableReinitialize: true
    });

    const {values, setFieldValue, handleSubmit} = formik;

    return (
        <LoggedInView fullWidth={false}>
            <Breadcrumbs links={breadcrumbLinks}/>
            {requestStatus === RequestStatus.Failed &&
            usersState.errors.length > 0 && (
                <div className="message msg-error">
                    <div>
                        <h2>Viga:</h2>
                        {usersState.errors.map((error, index) => (
                            <span key={index}>{error}<br/></span>
                        ))}
                    </div>
                </div>
            )}
            <FormikProvider value={formik}>
                <Form onSubmit={handleSubmit}>
                    <div className="form">
                        <h2>Kasutaja Andmed</h2>
                        <table className="form">
                            <tbody>
                            <ElogInput label="Kasutajanimi" name="username" mandatory={true}/>
                            <ElogInput label="Parool" name="password" type="password" mandatory={true}/>
                            <ElogInput label="Eesnimi" name="firstname" mandatory={true}/>
                            <ElogInput label="Perekonnanimi" name="lastname" mandatory={true}/>
                            <ElogInput label="Telefon" name="phone" mandatory={true}/>
                            <ElogInput label="Vaikimisi email" name="email" mandatory={true}/>
                            <ElogInput label="Eesti email" name="emailEst" mandatory={true}/>
                            <ElogInput label="Soome email" name="emailFin" mandatory={true}/>
                            <ElogInput label="Rootsi email" name="emailSwe" mandatory={true}/>
                            <ElogInput label="Pakkumiste email" name="quotesEmail"/>
                            <ElogTextarea label="Emaili signatuur" name="signatuee"/>
                            <ElogCheckbox label="Logistik" name="logistician"/>
                            <ElogCheckbox label="Raamatupidaja" name="accountant"/>
                            <ElogCheckbox label="On Checker" name="isChecker"/>
                            <ElogCheckbox label="Tollideklarant" name="customs"/>
                            <ElogCheckbox label="Offline" name="offline"/>
                            <ElogCheckbox label="Administraatori liige" name="adminMember"/>
                            <ElogCheckbox label="Kuva statistikat" name="showStatistics"/>
                            <ElogInput label="Kasumi eesmärk" name="profitGoal"/>
                            {values?.logistician && (
                                <ElogInput label="Kasumi eesmärk aastas" name="profitGoalAnnual"/>
                            )}
                            {values?.customs && (
                                <>
                                    <ElogInput label="Tollid logistikutele aasta eesmärks" name="profitGoalCustoms"/>
                                    <ElogInput label="Otsetollid kokku aasta eesmärk" name="profitGoalDirect"/>
                                </>
                            )}
                            </tbody>
                        </table>
                    </div>
                    <div className="action clear">
                        <p>
                            <button type="submit">
                                <span><strong>Sisesta</strong></span>
                            </button>
                            <Link to="/users">Tühista</Link>
                        </p>
                    </div>
                </Form>
            </FormikProvider>
        </LoggedInView>
    );
};